<template>
  <div>
    <div v-if="showloading">
      <loader-appie/>
    </div>
    <!--    <sidebar-home-one :sidebar="sidebar" :side="SideMenu" @toggleSidebar="toggleSidebar" :menuItems="navs"/>-->
<!--    <header-home-two @toggleSidebar="toggleSidebar" :side="SideMenu" :titleWordd="titleWord" :custCare="customerCare"-->
<!--                     :menuItems="navs"/>-->
    <section class="appie-testimonial-2-area" id="testimonial">
      <div class="container " v-if="!showloading">
        <div class="row">
          <div class="col-md-3 whitebackground menudiv" >
            <menubar @toggleSidebar="toggleSidebar" :side="SideMenu" :titleWordd="titleWord" :custCare="customerCare"
                     :menuItems="navs"/>
          </div>
          <div class="col-md-9  graybackground contentdiv" >
            <div class="col-lg-12 mt-2">
              <div>

                <Commonprofile/>
              </div>
              <br>
              <div class="row">
                <div class="col-lg-12">

                  <iframe
                      :src="frameurl"
                      frameborder="0"
                      allowfullscreen
                      style="width: 100%; height: 100vh; overflow: hidden;"
                  ></iframe>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
      <div>
        <b-modal id="modal-center1" centered title="BootstrapVue">
          <div class="row">
            <!-- First Card Row -->
            <div class="col-12 col-lg-12 col-md-12 mb-4" v-for="(customerCareData,index) in customerCare" :key="index">
              <span v-html="stripTags(customerCareData.label)"></span>
              <div class="card" >
                <div class="card-body">
                  <div class="row align-items-center">
                    <div class="col-2 col-lg-2 col-md-2">
                      <div class="d-flex justify-content-center align-items-center h-100">
                        <i class="fa fa-phone flipped" style="background: white;" aria-hidden="true"></i>
                      </div>
                    </div>
                    <div class="col-8 col-lg-8 col-md-8">
                      <div class="d-flex flex-column justify-content-center h-100">
                        <span>{{ customerCareData.name }}</span>
                        <span v-html="customerCareData.description"></span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </b-modal>
      </div>
    </section>
    <div class="back-to-top back-to-top-2">
      <a href="#"><i class="fal fa-arrow-up"></i></a>
    </div>
    <!--====== APPIE BACK TO TOP PART ENDS ======-->
  </div>
</template>
<script>
import CryptoJS from 'crypto-js';
import video_bg_thumb from "@/assets/images/video-thumb-1.jpg"
import hero_img from '@/assets/images/hero-thumb-3.png'
// import {callAxiosWithConfig} from "@/main";
import {right} from "core-js/internals/array-reduce";
import Commonprofile from "@/components/HomePage/commonprofilediv.vue";
import Menubar from "@/components/HomePage/menu.vue";
import LoaderAppie from "@/components/LoaderAppie.vue";
// import SidebarHomeOne from "@/components/HomeOne/SidebarHomeOne.vue";
// import HeaderHomeTwo from '../HomePage/Header.vue'

export default {
  props: {
    section_heading: {
      type: String,
    },
    more_heading: {
      type: String
    },
    description: {
      type: String
    },
    grid_items: {
      type: Array,
    }
  },
  components: {
    LoaderAppie,
    Menubar, Commonprofile
    // SidebarHomeOne,
    // HeaderHomeTwo,

  },
  data() {
    return {
      showloading:false,
      frameurl:'',
      title: '',
      template: '',
      SideMenu: {},
      titleWord: '',
      customerCare: {},
      urlData: '',
      ViewPosttitle: '',
      sidebar: false,
      navs: [
        {
          // name:'contact',
          name: 'Home',
          path: '/home-page'
        },
        {
          name: 'Profile',
          childrens: [
            {
              // name:'Home 1',
              name: 'Update KYC',
              path: '/'
            },
            {
              // name:'Home 2',
              name: 'Update Profile',
              path: '/home-two'
            },
            {
              // name:'Home 3',
              name: 'View Profile',
              path: '/home-three'
            },
            {
              // name:'Home 4',
              name: 'Viewed Profiles',
              path: '/home-four'
            },
            // {
            //   // name:'Home 5',
            //   name: 'Change Mobile Number',
            //   path: '/home-five'
            // },


          ],
        },

        {
          // name:'contact',
          name: 'Customer Care',
          path: '/contact'
        },

        // {
        //   name:'Notification',
        //   path:'/notifi'
        // }
      ],
      hero_img: hero_img,
      video_bg_thumb: video_bg_thumb
    }
  },
  mounted() {
    document.addEventListener('scroll', this.topToBottom)
  },

  async created() {

    if (this.$route.query.page) {
      this.showloading=true;
      const pageurl = this.$route.query.page;
      const decryptedString = this.decryptUrl(pageurl);
      this.frameurl = decryptedString + '&from=web';
      // alert(this.frameurl);
      // console.log(this.frameurl)
      this.SideMenu = JSON.parse(localStorage.getItem("SideMenu"));
      this.titleWord = JSON.parse(localStorage.getItem("titleWord"));
      this.customerCare = JSON.parse(localStorage.getItem("customerCare"));
      this.showloading=false;
      // console.log(this.SideMenu)
      this.$emit("tempData",  this.SideMenu);
      this.$emit("title", this.titleWord);
      this.$emit("customerCare", this.customerCare);
    }

  },

  methods: {
    encryptUrl(url) {
      const ciphertext = CryptoJS.AES.encrypt(url, 'secret key 123').toString();
      return ciphertext;
    },
    decryptUrl(ciphertext) {
      const bytes = CryptoJS.AES.decrypt(ciphertext, 'secret key 123');
      const originalUrl = bytes.toString(CryptoJS.enc.Utf8);
      return originalUrl;
    },
    right,
    topToBottom() {
      const result = document.querySelector('.back-to-top')
      if (document.body.scrollTop > window.innerHeight || document.documentElement.scrollTop > window.innerHeight) {
        result.style.display = "block";
      } else {
        result.style.display = "none";
      }
    },
    stripTags(html) {
      // Regular expression to remove HTML tags
      return html.replace(/<[^>]+>/g, '');
    },


    toggleSidebar() {
      this.sidebar = !this.sidebar
    },

    async Click_template5(activity, url) {

      const inputString = activity;
      const lastPart = inputString.split('.').pop();
      this.urlData = url;
      if (lastPart === 'Employer_Dynamic_Home_Activity') {
        const encryptedString = this.encryptUrl(url);
        await this.$router.push(`/candidate-profile?page=${encodeURIComponent(encryptedString)}`);
      } else if (lastPart === 'Employer_Common_Webview_Activity') {
        // alert('dfasdf')
        window.location.href = this.urlData;
      }
    },
    async imageurl(url) {
      // alert(activity)
      // const encryptedString = this.encryptUrl(url);
      window.location.href = url;
    },

    async GetPlanimage(activity, url) {
      const inputString = activity;
      const lastPart = inputString.split('.').pop();
      this.urlData = url;
      if (lastPart === 'Employer_Common_Webview_Activity') {
        window.location.href = this.urlData
      } else if (lastPart === 'Employer_Company_Register') {
        const encryptedString = this.encryptUrl(url);
        await this.$router.push(`/company-register?page=${encodeURIComponent(encryptedString)}`);
      }

    },

    Encrypt(str) {
      // return str.split('').map(char => char.charCodeAt(0)).join('-');
      return str.replace(/[a-zA-Z]/g, function (char) {
        // Replace each alphabetic character with its encrypted value
        const charCode = char.charCodeAt(0);
        const encryptedCharCode = charCode + 1; // You can use a different encryption logic
        return String.fromCharCode(encryptedCharCode);
      });
    },

    async postJob(activity, url) {
      // const encryptedString = this.encryptUrl(url);
      // await this.$router.push(`/view-post?page=${encodeURIComponent(encryptedString)}`);

      const inputString = activity;
      const lastPart = inputString.split('.').pop();
      this.urlData = url;

      if (lastPart === 'Employer_Dynamic_Home_Activity') {
        const encryptedString = this.encryptUrl(url);
        await this.$router.push(`/view-post?page=${encodeURIComponent(encryptedString)}`);


      } else if (lastPart === 'Employer_Company_Register') {
        const encryptedString = this.encryptUrl(url);
        await this.$router.push(`/company-register?page=${encodeURIComponent(encryptedString)}`);
      }

    }
  }

}
</script>



